import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { PersianTitlesService } from '../../core/services/persian-titles.service';
import { navbarItems } from './navbar-items';
import { NotifsAndMessagesService } from './notificatoins-and-messages-dropdown/notifs-and-messages.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnDestroy {
  isNavbarCollapsed: boolean = true;
  isNotifDropDownOpen: boolean = false;
  navBarItems = navbarItems(this.persianTitlesService);

  // Labels
  systemNameLabel: string = '';
  notificationsResponse: any;
  messagesResponse: any;

  constructor(
    private persianTitlesService: PersianTitlesService,
    private notifsAndMessagesService: NotifsAndMessagesService,
    private router: Router,
  ) {}

  get unseenNotifCount() {
    return (
      this.notificationsResponse?.results.filter((e) => !e.seen).length ?? 0
    );
  }
  get unseenMessageCount() {
    return this.messagesResponse?.results.filter((e) => !e.seen).length ?? 0;
  }

  notifFetchInterval: any;
  async ngOnInit() {
    // Init Labels
    this.systemNameLabel = this.persianTitlesService.Items.SystemName;
    this.notificationsResponse = await firstValueFrom(
      this.notifsAndMessagesService.getNotifications(),
    );
    this.messagesResponse = await firstValueFrom(
      this.notifsAndMessagesService.getMessages(),
    );
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  ngOnDestroy(): void {
    this.notifFetchInterval && clearInterval(this.notifFetchInterval);
  }

  navItemClick(e: any) {
    if (e && e.itemData.urlParts) {
      this.router.navigate(e.itemData.urlParts);
    }
  }
}
